import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitText'
})
export class LimitTextPipe implements PipeTransform
{
  transform(value: string, limit: number = 30)  : string
  {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
}